import React, {useCallback, useEffect} from "react";
import {initReactI18next, useTranslation as useTranslation$1, Trans, I18nextProvider} from "../../../../pkg/react-i18next.js";
import i18next from "../../../../pkg/i18next.js";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
var check = function(it) {
  return it && it.Math == Math && it;
};
var global$y = check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || check(typeof self == "object" && self) || check(typeof commonjsGlobal == "object" && commonjsGlobal) || function() {
  return this;
}() || Function("return this")();
var objectGetOwnPropertyDescriptor = {};
var fails$e = function(exec2) {
  try {
    return !!exec2();
  } catch (error) {
    return true;
  }
};
var fails$d = fails$e;
var descriptors = !fails$d(function() {
  return Object.defineProperty({}, 1, {
    get: function() {
      return 7;
    }
  })[1] != 7;
});
var fails$c = fails$e;
var functionBindNative = !fails$c(function() {
  var test2 = function() {
  }.bind();
  return typeof test2 != "function" || test2.hasOwnProperty("prototype");
});
var NATIVE_BIND$3 = functionBindNative;
var call$a = Function.prototype.call;
var functionCall = NATIVE_BIND$3 ? call$a.bind(call$a) : function() {
  return call$a.apply(call$a, arguments);
};
var objectPropertyIsEnumerable = {};
var $propertyIsEnumerable$2 = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor$1 && !$propertyIsEnumerable$2.call({
  1: 2
}, 1);
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$1(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$2;
var createPropertyDescriptor$5 = function(bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value
  };
};
var NATIVE_BIND$2 = functionBindNative;
var FunctionPrototype$3 = Function.prototype;
var bind$3 = FunctionPrototype$3.bind;
var call$9 = FunctionPrototype$3.call;
var uncurryThis$k = NATIVE_BIND$2 && bind$3.bind(call$9, call$9);
var functionUncurryThis = NATIVE_BIND$2 ? function(fn) {
  return fn && uncurryThis$k(fn);
} : function(fn) {
  return fn && function() {
    return call$9.apply(fn, arguments);
  };
};
var uncurryThis$j = functionUncurryThis;
var toString$6 = uncurryThis$j({}.toString);
var stringSlice$2 = uncurryThis$j("".slice);
var classofRaw$1 = function(it) {
  return stringSlice$2(toString$6(it), 8, -1);
};
var global$x = global$y;
var uncurryThis$i = functionUncurryThis;
var fails$b = fails$e;
var classof$7 = classofRaw$1;
var Object$5 = global$x.Object;
var split = uncurryThis$i("".split);
var indexedObject = fails$b(function() {
  return !Object$5("z").propertyIsEnumerable(0);
}) ? function(it) {
  return classof$7(it) == "String" ? split(it, "") : Object$5(it);
} : Object$5;
var global$w = global$y;
var TypeError$a = global$w.TypeError;
var requireObjectCoercible$3 = function(it) {
  if (it == void 0)
    throw TypeError$a("Can't call method on " + it);
  return it;
};
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$2 = requireObjectCoercible$3;
var toIndexedObject$a = function(it) {
  return IndexedObject$1(requireObjectCoercible$2(it));
};
var isCallable$h = function(argument) {
  return typeof argument == "function";
};
var isCallable$g = isCallable$h;
var isObject$8 = function(it) {
  return typeof it == "object" ? it !== null : isCallable$g(it);
};
var global$v = global$y;
var isCallable$f = isCallable$h;
var aFunction = function(argument) {
  return isCallable$f(argument) ? argument : void 0;
};
var getBuiltIn$6 = function(namespace, method) {
  return arguments.length < 2 ? aFunction(global$v[namespace]) : global$v[namespace] && global$v[namespace][method];
};
var uncurryThis$h = functionUncurryThis;
var objectIsPrototypeOf = uncurryThis$h({}.isPrototypeOf);
var getBuiltIn$5 = getBuiltIn$6;
var engineUserAgent = getBuiltIn$5("navigator", "userAgent") || "";
var global$u = global$y;
var userAgent = engineUserAgent;
var process = global$u.process;
var Deno = global$u.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
  match = v8.split(".");
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match)
      version = +match[1];
  }
}
var engineV8Version = version;
var V8_VERSION$1 = engineV8Version;
var fails$a = fails$e;
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$a(function() {
  var symbol = Symbol();
  return !String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});
var NATIVE_SYMBOL$3 = nativeSymbol;
var useSymbolAsUid = NATIVE_SYMBOL$3 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var global$t = global$y;
var getBuiltIn$4 = getBuiltIn$6;
var isCallable$e = isCallable$h;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;
var Object$4 = global$t.Object;
var isSymbol$3 = USE_SYMBOL_AS_UID$1 ? function(it) {
  return typeof it == "symbol";
} : function(it) {
  var $Symbol2 = getBuiltIn$4("Symbol");
  return isCallable$e($Symbol2) && isPrototypeOf$3($Symbol2.prototype, Object$4(it));
};
var global$s = global$y;
var String$4 = global$s.String;
var tryToString$2 = function(argument) {
  try {
    return String$4(argument);
  } catch (error) {
    return "Object";
  }
};
var global$r = global$y;
var isCallable$d = isCallable$h;
var tryToString$1 = tryToString$2;
var TypeError$9 = global$r.TypeError;
var aCallable$3 = function(argument) {
  if (isCallable$d(argument))
    return argument;
  throw TypeError$9(tryToString$1(argument) + " is not a function");
};
var aCallable$2 = aCallable$3;
var getMethod$3 = function(V, P) {
  var func = V[P];
  return func == null ? void 0 : aCallable$2(func);
};
var global$q = global$y;
var call$8 = functionCall;
var isCallable$c = isCallable$h;
var isObject$7 = isObject$8;
var TypeError$8 = global$q.TypeError;
var ordinaryToPrimitive$1 = function(input, pref) {
  var fn, val;
  if (pref === "string" && isCallable$c(fn = input.toString) && !isObject$7(val = call$8(fn, input)))
    return val;
  if (isCallable$c(fn = input.valueOf) && !isObject$7(val = call$8(fn, input)))
    return val;
  if (pref !== "string" && isCallable$c(fn = input.toString) && !isObject$7(val = call$8(fn, input)))
    return val;
  throw TypeError$8("Can't convert object to primitive value");
};
var shared$4 = {
  exports: {}
};
var global$p = global$y;
var defineProperty$5 = Object.defineProperty;
var setGlobal$3 = function(key, value) {
  try {
    defineProperty$5(global$p, key, {
      value,
      configurable: true,
      writable: true
    });
  } catch (error) {
    global$p[key] = value;
  }
  return value;
};
var global$o = global$y;
var setGlobal$2 = setGlobal$3;
var SHARED = "__core-js_shared__";
var store$3 = global$o[SHARED] || setGlobal$2(SHARED, {});
var sharedStore = store$3;
var store$2 = sharedStore;
(shared$4.exports = function(key, value) {
  return store$2[key] || (store$2[key] = value !== void 0 ? value : {});
})("versions", []).push({
  version: "3.21.0",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.21.0/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var global$n = global$y;
var requireObjectCoercible$1 = requireObjectCoercible$3;
var Object$3 = global$n.Object;
var toObject$6 = function(argument) {
  return Object$3(requireObjectCoercible$1(argument));
};
var uncurryThis$g = functionUncurryThis;
var toObject$5 = toObject$6;
var hasOwnProperty = uncurryThis$g({}.hasOwnProperty);
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$5(it), key);
};
var uncurryThis$f = functionUncurryThis;
var id = 0;
var postfix = Math.random();
var toString$5 = uncurryThis$f(1 .toString);
var uid$3 = function(key) {
  return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString$5(++id + postfix, 36);
};
var global$m = global$y;
var shared$3 = shared$4.exports;
var hasOwn$b = hasOwnProperty_1;
var uid$2 = uid$3;
var NATIVE_SYMBOL$2 = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var WellKnownSymbolsStore$1 = shared$3("wks");
var Symbol$1 = global$m.Symbol;
var symbolFor = Symbol$1 && Symbol$1["for"];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$2;
var wellKnownSymbol$g = function(name) {
  if (!hasOwn$b(WellKnownSymbolsStore$1, name) || !(NATIVE_SYMBOL$2 || typeof WellKnownSymbolsStore$1[name] == "string")) {
    var description = "Symbol." + name;
    if (NATIVE_SYMBOL$2 && hasOwn$b(Symbol$1, name)) {
      WellKnownSymbolsStore$1[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore$1[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore$1[name] = createWellKnownSymbol(description);
    }
  }
  return WellKnownSymbolsStore$1[name];
};
var global$l = global$y;
var call$7 = functionCall;
var isObject$6 = isObject$8;
var isSymbol$2 = isSymbol$3;
var getMethod$2 = getMethod$3;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$f = wellKnownSymbol$g;
var TypeError$7 = global$l.TypeError;
var TO_PRIMITIVE$1 = wellKnownSymbol$f("toPrimitive");
var toPrimitive$1 = function(input, pref) {
  if (!isObject$6(input) || isSymbol$2(input))
    return input;
  var exoticToPrim = getMethod$2(input, TO_PRIMITIVE$1);
  var result;
  if (exoticToPrim) {
    if (pref === void 0)
      pref = "default";
    result = call$7(exoticToPrim, input, pref);
    if (!isObject$6(result) || isSymbol$2(result))
      return result;
    throw TypeError$7("Can't convert object to primitive value");
  }
  if (pref === void 0)
    pref = "number";
  return ordinaryToPrimitive(input, pref);
};
var toPrimitive = toPrimitive$1;
var isSymbol$1 = isSymbol$3;
var toPropertyKey$4 = function(argument) {
  var key = toPrimitive(argument, "string");
  return isSymbol$1(key) ? key : key + "";
};
var global$k = global$y;
var isObject$5 = isObject$8;
var document$1 = global$k.document;
var EXISTS$1 = isObject$5(document$1) && isObject$5(document$1.createElement);
var documentCreateElement$2 = function(it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};
var DESCRIPTORS$c = descriptors;
var fails$9 = fails$e;
var createElement = documentCreateElement$2;
var ie8DomDefine = !DESCRIPTORS$c && !fails$9(function() {
  return Object.defineProperty(createElement("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
});
var DESCRIPTORS$b = descriptors;
var call$6 = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$9 = toIndexedObject$a;
var toPropertyKey$3 = toPropertyKey$4;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var $getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$b ? $getOwnPropertyDescriptor$2 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$9(O);
  P = toPropertyKey$3(P);
  if (IE8_DOM_DEFINE$1)
    try {
      return $getOwnPropertyDescriptor$2(O, P);
    } catch (error) {
    }
  if (hasOwn$a(O, P))
    return createPropertyDescriptor$4(!call$6(propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var objectDefineProperty = {};
var DESCRIPTORS$a = descriptors;
var fails$8 = fails$e;
var v8PrototypeDefineBug = DESCRIPTORS$a && fails$8(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: false
  }).prototype != 42;
});
var global$j = global$y;
var isObject$4 = isObject$8;
var String$3 = global$j.String;
var TypeError$6 = global$j.TypeError;
var anObject$b = function(argument) {
  if (isObject$4(argument))
    return argument;
  throw TypeError$6(String$3(argument) + " is not an object");
};
var global$i = global$y;
var DESCRIPTORS$9 = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$a = anObject$b;
var toPropertyKey$2 = toPropertyKey$4;
var TypeError$5 = global$i.TypeError;
var $defineProperty$1 = Object.defineProperty;
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = "enumerable";
var CONFIGURABLE$1 = "configurable";
var WRITABLE = "writable";
objectDefineProperty.f = DESCRIPTORS$9 ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$a(O);
  P = toPropertyKey$2(P);
  anObject$a(Attributes);
  if (typeof O === "function" && P === "prototype" && "value" in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  }
  return $defineProperty$1(O, P, Attributes);
} : $defineProperty$1 : function defineProperty2(O, P, Attributes) {
  anObject$a(O);
  P = toPropertyKey$2(P);
  anObject$a(Attributes);
  if (IE8_DOM_DEFINE)
    try {
      return $defineProperty$1(O, P, Attributes);
    } catch (error) {
    }
  if ("get" in Attributes || "set" in Attributes)
    throw TypeError$5("Accessors not supported");
  if ("value" in Attributes)
    O[P] = Attributes.value;
  return O;
};
var DESCRIPTORS$8 = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;
var createNonEnumerableProperty$5 = DESCRIPTORS$8 ? function(object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
  object[key] = value;
  return object;
};
var redefine$6 = {
  exports: {}
};
var uncurryThis$e = functionUncurryThis;
var isCallable$b = isCallable$h;
var store$1 = sharedStore;
var functionToString$1 = uncurryThis$e(Function.toString);
if (!isCallable$b(store$1.inspectSource)) {
  store$1.inspectSource = function(it) {
    return functionToString$1(it);
  };
}
var inspectSource$3 = store$1.inspectSource;
var global$h = global$y;
var isCallable$a = isCallable$h;
var inspectSource$2 = inspectSource$3;
var WeakMap$1 = global$h.WeakMap;
var nativeWeakMap = isCallable$a(WeakMap$1) && /native code/.test(inspectSource$2(WeakMap$1));
var shared$2 = shared$4.exports;
var uid$1 = uid$3;
var keys = shared$2("keys");
var sharedKey$4 = function(key) {
  return keys[key] || (keys[key] = uid$1(key));
};
var hiddenKeys$5 = {};
var NATIVE_WEAK_MAP = nativeWeakMap;
var global$g = global$y;
var uncurryThis$d = functionUncurryThis;
var isObject$3 = isObject$8;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$9 = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$4 = hiddenKeys$5;
var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var TypeError$4 = global$g.TypeError;
var WeakMap = global$g.WeakMap;
var set, get, has;
var enforce = function(it) {
  return has(it) ? get(it) : set(it, {});
};
var getterFor = function(TYPE) {
  return function(it) {
    var state;
    if (!isObject$3(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$4("Incompatible receiver, " + TYPE + " required");
    }
    return state;
  };
};
if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$d(store.get);
  var wmhas = uncurryThis$d(store.has);
  var wmset = uncurryThis$d(store.set);
  set = function(it, metadata) {
    if (wmhas(store, it))
      throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function(it) {
    return wmget(store, it) || {};
  };
  has = function(it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$3("state");
  hiddenKeys$4[STATE] = true;
  set = function(it, metadata) {
    if (hasOwn$9(it, STATE))
      throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function(it) {
    return hasOwn$9(it, STATE) ? it[STATE] : {};
  };
  has = function(it) {
    return hasOwn$9(it, STATE);
  };
}
var internalState = {
  set,
  get,
  has,
  enforce,
  getterFor
};
var DESCRIPTORS$7 = descriptors;
var hasOwn$8 = hasOwnProperty_1;
var FunctionPrototype$2 = Function.prototype;
var getDescriptor = DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn$8(FunctionPrototype$2, "name");
var PROPER = EXISTS && function something() {
}.name === "something";
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$7 || DESCRIPTORS$7 && getDescriptor(FunctionPrototype$2, "name").configurable);
var functionName = {
  EXISTS,
  PROPER,
  CONFIGURABLE
};
var global$f = global$y;
var isCallable$9 = isCallable$h;
var hasOwn$7 = hasOwnProperty_1;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$3 = internalState;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var getInternalState$3 = InternalStateModule$3.get;
var enforceInternalState = InternalStateModule$3.enforce;
var TEMPLATE = String(String).split("String");
(redefine$6.exports = function(O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== void 0 ? options.name : key;
  var state;
  if (isCallable$9(value)) {
    if (String(name).slice(0, 7) === "Symbol(") {
      name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    }
    if (!hasOwn$7(value, "name") || CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
      createNonEnumerableProperty$3(value, "name", name);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof name == "string" ? name : "");
    }
  }
  if (O === global$f) {
    if (simple)
      O[key] = value;
    else
      setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple)
    O[key] = value;
  else
    createNonEnumerableProperty$3(O, key, value);
})(Function.prototype, "toString", function toString() {
  return isCallable$9(this) && getInternalState$3(this).source || inspectSource$1(this);
});
var objectGetOwnPropertyNames = {};
var ceil = Math.ceil;
var floor = Math.floor;
var toIntegerOrInfinity$3 = function(argument) {
  var number = +argument;
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};
var toIntegerOrInfinity$2 = toIntegerOrInfinity$3;
var max$2 = Math.max;
var min$1 = Math.min;
var toAbsoluteIndex$3 = function(index, length) {
  var integer = toIntegerOrInfinity$2(index);
  return integer < 0 ? max$2(integer + length, 0) : min$1(integer, length);
};
var toIntegerOrInfinity$1 = toIntegerOrInfinity$3;
var min = Math.min;
var toLength$1 = function(argument) {
  return argument > 0 ? min(toIntegerOrInfinity$1(argument), 9007199254740991) : 0;
};
var toLength = toLength$1;
var lengthOfArrayLike$5 = function(obj) {
  return toLength(obj.length);
};
var toIndexedObject$8 = toIndexedObject$a;
var toAbsoluteIndex$2 = toAbsoluteIndex$3;
var lengthOfArrayLike$4 = lengthOfArrayLike$5;
var createMethod$3 = function(IS_INCLUDES) {
  return function($this, el, fromIndex) {
    var O = toIndexedObject$8($this);
    var length = lengthOfArrayLike$4(O);
    var index = toAbsoluteIndex$2(fromIndex, length);
    var value;
    if (IS_INCLUDES && el != el)
      while (length > index) {
        value = O[index++];
        if (value != value)
          return true;
      }
    else
      for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el)
          return IS_INCLUDES || index || 0;
      }
    return !IS_INCLUDES && -1;
  };
};
var arrayIncludes = {
  includes: createMethod$3(true),
  indexOf: createMethod$3(false)
};
var uncurryThis$c = functionUncurryThis;
var hasOwn$6 = hasOwnProperty_1;
var toIndexedObject$7 = toIndexedObject$a;
var indexOf = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$5;
var push$3 = uncurryThis$c([].push);
var objectKeysInternal = function(object, names) {
  var O = toIndexedObject$7(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O)
    !hasOwn$6(hiddenKeys$3, key) && hasOwn$6(O, key) && push$3(result, key);
  while (names.length > i)
    if (hasOwn$6(O, key = names[i++])) {
      ~indexOf(result, key) || push$3(result, key);
    }
  return result;
};
var enumBugKeys$3 = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;
var hiddenKeys$2 = enumBugKeys$2.concat("length", "prototype");
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$2);
};
var objectGetOwnPropertySymbols = {};
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var getBuiltIn$3 = getBuiltIn$6;
var uncurryThis$b = functionUncurryThis;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$9 = anObject$b;
var concat = uncurryThis$b([].concat);
var ownKeys$2 = getBuiltIn$3("Reflect", "ownKeys") || function ownKeys(it) {
  var keys4 = getOwnPropertyNamesModule$1.f(anObject$9(it));
  var getOwnPropertySymbols3 = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols3 ? concat(keys4, getOwnPropertySymbols3(it)) : keys4;
};
var hasOwn$5 = hasOwnProperty_1;
var ownKeys$1 = ownKeys$2;
var getOwnPropertyDescriptorModule$2 = objectGetOwnPropertyDescriptor;
var definePropertyModule$4 = objectDefineProperty;
var copyConstructorProperties$2 = function(target, source, exceptions) {
  var keys4 = ownKeys$1(source);
  var defineProperty5 = definePropertyModule$4.f;
  var getOwnPropertyDescriptor4 = getOwnPropertyDescriptorModule$2.f;
  for (var i = 0; i < keys4.length; i++) {
    var key = keys4[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty5(target, key, getOwnPropertyDescriptor4(source, key));
    }
  }
};
var fails$7 = fails$e;
var isCallable$8 = isCallable$h;
var replacement = /#|\.prototype\./;
var isForced$1 = function(feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true : value == NATIVE ? false : isCallable$8(detection) ? fails$7(detection) : !!detection;
};
var normalize = isForced$1.normalize = function(string) {
  return String(string).replace(replacement, ".").toLowerCase();
};
var data = isForced$1.data = {};
var NATIVE = isForced$1.NATIVE = "N";
var POLYFILL = isForced$1.POLYFILL = "P";
var isForced_1 = isForced$1;
var global$e = global$y;
var getOwnPropertyDescriptor2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var redefine$5 = redefine$6.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced = isForced_1;
var _export = function(options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$e;
  } else if (STATIC) {
    target = global$e[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$e[TARGET] || {}).prototype;
  }
  if (target)
    for (key in source) {
      sourceProperty = source[key];
      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor2(target, key);
        targetProperty = descriptor && descriptor.value;
      } else
        targetProperty = target[key];
      FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
      if (!FORCED && targetProperty !== void 0) {
        if (typeof sourceProperty == typeof targetProperty)
          continue;
        copyConstructorProperties$1(sourceProperty, targetProperty);
      }
      if (options.sham || targetProperty && targetProperty.sham) {
        createNonEnumerableProperty$2(sourceProperty, "sham", true);
      }
      redefine$5(target, key, sourceProperty, options);
    }
};
var toPropertyKey$1 = toPropertyKey$4;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var createProperty$4 = function(object, key, value) {
  var propertyKey = toPropertyKey$1(key);
  if (propertyKey in object)
    definePropertyModule$3.f(object, propertyKey, createPropertyDescriptor$2(0, value));
  else
    object[propertyKey] = value;
};
var $$7 = _export;
var DESCRIPTORS$6 = descriptors;
var ownKeys2 = ownKeys$2;
var toIndexedObject$6 = toIndexedObject$a;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var createProperty$3 = createProperty$4;
$$7({
  target: "Object",
  stat: true,
  sham: !DESCRIPTORS$6
}, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject$6(object);
    var getOwnPropertyDescriptor4 = getOwnPropertyDescriptorModule$1.f;
    var keys4 = ownKeys2(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys4.length > index) {
      descriptor = getOwnPropertyDescriptor4(O, key = keys4[index++]);
      if (descriptor !== void 0)
        createProperty$3(result, key, descriptor);
    }
    return result;
  }
});
var NATIVE_BIND$1 = functionBindNative;
var FunctionPrototype$1 = Function.prototype;
var apply$1 = FunctionPrototype$1.apply;
var call$5 = FunctionPrototype$1.call;
var functionApply = typeof Reflect == "object" && Reflect.apply || (NATIVE_BIND$1 ? call$5.bind(apply$1) : function() {
  return call$5.apply(apply$1, arguments);
});
var classof$6 = classofRaw$1;
var isArray$3 = Array.isArray || function isArray(argument) {
  return classof$6(argument) == "Array";
};
var wellKnownSymbol$e = wellKnownSymbol$g;
var TO_STRING_TAG$3 = wellKnownSymbol$e("toStringTag");
var test = {};
test[TO_STRING_TAG$3] = "z";
var toStringTagSupport = String(test) === "[object z]";
var global$d = global$y;
var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$7 = isCallable$h;
var classofRaw = classofRaw$1;
var wellKnownSymbol$d = wellKnownSymbol$g;
var TO_STRING_TAG$2 = wellKnownSymbol$d("toStringTag");
var Object$2 = global$d.Object;
var CORRECT_ARGUMENTS = classofRaw(function() {
  return arguments;
}()) == "Arguments";
var tryGet = function(it, key) {
  try {
    return it[key];
  } catch (error) {
  }
};
var classof$5 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function(it) {
  var O, tag, result;
  return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object$2(it), TO_STRING_TAG$2)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable$7(O.callee) ? "Arguments" : result;
};
var global$c = global$y;
var classof$4 = classof$5;
var String$2 = global$c.String;
var toString$4 = function(argument) {
  if (classof$4(argument) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return String$2(argument);
};
var objectDefineProperties = {};
var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;
var objectKeys$3 = Object.keys || function keys2(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};
var DESCRIPTORS$5 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$2 = objectDefineProperty;
var anObject$8 = anObject$b;
var toIndexedObject$5 = toIndexedObject$a;
var objectKeys$2 = objectKeys$3;
objectDefineProperties.f = DESCRIPTORS$5 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var props = toIndexedObject$5(Properties);
  var keys4 = objectKeys$2(Properties);
  var length = keys4.length;
  var index = 0;
  var key;
  while (length > index)
    definePropertyModule$2.f(O, key = keys4[index++], props[key]);
  return O;
};
var getBuiltIn$2 = getBuiltIn$6;
var html$1 = getBuiltIn$2("document", "documentElement");
var anObject$7 = anObject$b;
var definePropertiesModule$1 = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$1 = hiddenKeys$5;
var html = html$1;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$4;
var GT = ">";
var LT = "<";
var PROTOTYPE$1 = "prototype";
var SCRIPT = "script";
var IE_PROTO$1 = sharedKey$2("IE_PROTO");
var EmptyConstructor = function() {
};
var scriptTag = function(content) {
  return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function(activeXDocument2) {
  activeXDocument2.write(scriptTag(""));
  activeXDocument2.close();
  var temp = activeXDocument2.parentWindow.Object;
  activeXDocument2 = null;
  return temp;
};
var NullProtoObjectViaIFrame = function() {
  var iframe = documentCreateElement$1("iframe");
  var JS = "java" + SCRIPT + ":";
  var iframeDocument;
  iframe.style.display = "none";
  html.appendChild(iframe);
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag("document.F=Object"));
  iframeDocument.close();
  return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function() {
  try {
    activeXDocument = new ActiveXObject("htmlfile");
  } catch (error) {
  }
  NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
  var length = enumBugKeys.length;
  while (length--)
    delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};
hiddenKeys$1[IE_PROTO$1] = true;
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    result[IE_PROTO$1] = O;
  } else
    result = NullProtoObject();
  return Properties === void 0 ? result : definePropertiesModule$1.f(result, Properties);
};
var objectGetOwnPropertyNamesExternal = {};
var global$b = global$y;
var toAbsoluteIndex$1 = toAbsoluteIndex$3;
var lengthOfArrayLike$3 = lengthOfArrayLike$5;
var createProperty$2 = createProperty$4;
var Array$4 = global$b.Array;
var max$1 = Math.max;
var arraySliceSimple = function(O, start, end) {
  var length = lengthOfArrayLike$3(O);
  var k = toAbsoluteIndex$1(start, length);
  var fin = toAbsoluteIndex$1(end === void 0 ? length : end, length);
  var result = Array$4(max$1(fin - k, 0));
  for (var n = 0; k < fin; k++, n++)
    createProperty$2(result, n, O[k]);
  result.length = n;
  return result;
};
var classof$3 = classofRaw$1;
var toIndexedObject$4 = toIndexedObject$a;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var arraySlice$2 = arraySliceSimple;
var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var getWindowNames = function(it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return arraySlice$2(windowNames);
  }
};
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames2(it) {
  return windowNames && classof$3(it) == "Window" ? getWindowNames(it) : $getOwnPropertyNames$1(toIndexedObject$4(it));
};
var uncurryThis$a = functionUncurryThis;
var arraySlice$1 = uncurryThis$a([].slice);
var wellKnownSymbolWrapped = {};
var wellKnownSymbol$c = wellKnownSymbol$g;
wellKnownSymbolWrapped.f = wellKnownSymbol$c;
var global$a = global$y;
var path$1 = global$a;
var path = path$1;
var hasOwn$4 = hasOwnProperty_1;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$4 = objectDefineProperty.f;
var defineWellKnownSymbol$2 = function(NAME2) {
  var Symbol2 = path.Symbol || (path.Symbol = {});
  if (!hasOwn$4(Symbol2, NAME2))
    defineProperty$4(Symbol2, NAME2, {
      value: wrappedWellKnownSymbolModule$1.f(NAME2)
    });
};
var defineProperty$3 = objectDefineProperty.f;
var hasOwn$3 = hasOwnProperty_1;
var wellKnownSymbol$b = wellKnownSymbol$g;
var TO_STRING_TAG$1 = wellKnownSymbol$b("toStringTag");
var setToStringTag$3 = function(target, TAG, STATIC) {
  if (target && !STATIC)
    target = target.prototype;
  if (target && !hasOwn$3(target, TO_STRING_TAG$1)) {
    defineProperty$3(target, TO_STRING_TAG$1, {
      configurable: true,
      value: TAG
    });
  }
};
var uncurryThis$9 = functionUncurryThis;
var aCallable$1 = aCallable$3;
var NATIVE_BIND = functionBindNative;
var bind$2 = uncurryThis$9(uncurryThis$9.bind);
var functionBindContext = function(fn, that) {
  aCallable$1(fn);
  return that === void 0 ? fn : NATIVE_BIND ? bind$2(fn, that) : function() {
    return fn.apply(that, arguments);
  };
};
var uncurryThis$8 = functionUncurryThis;
var fails$6 = fails$e;
var isCallable$6 = isCallable$h;
var classof$2 = classof$5;
var getBuiltIn$1 = getBuiltIn$6;
var inspectSource = inspectSource$3;
var noop = function() {
};
var empty = [];
var construct = getBuiltIn$1("Reflect", "construct");
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis$8(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$6(argument))
    return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};
var isConstructorLegacy = function isConstructor2(argument) {
  if (!isCallable$6(argument))
    return false;
  switch (classof$2(argument)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return false;
  }
  try {
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};
isConstructorLegacy.sham = true;
var isConstructor$3 = !construct || fails$6(function() {
  var called;
  return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
    called = true;
  }) || called;
}) ? isConstructorLegacy : isConstructorModern;
var global$9 = global$y;
var isArray$2 = isArray$3;
var isConstructor$2 = isConstructor$3;
var isObject$2 = isObject$8;
var wellKnownSymbol$a = wellKnownSymbol$g;
var SPECIES$2 = wellKnownSymbol$a("species");
var Array$3 = global$9.Array;
var arraySpeciesConstructor$1 = function(originalArray) {
  var C;
  if (isArray$2(originalArray)) {
    C = originalArray.constructor;
    if (isConstructor$2(C) && (C === Array$3 || isArray$2(C.prototype)))
      C = void 0;
    else if (isObject$2(C)) {
      C = C[SPECIES$2];
      if (C === null)
        C = void 0;
    }
  }
  return C === void 0 ? Array$3 : C;
};
var arraySpeciesConstructor = arraySpeciesConstructor$1;
var arraySpeciesCreate$1 = function(originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var bind$1 = functionBindContext;
var uncurryThis$7 = functionUncurryThis;
var IndexedObject = indexedObject;
var toObject$4 = toObject$6;
var lengthOfArrayLike$2 = lengthOfArrayLike$5;
var arraySpeciesCreate = arraySpeciesCreate$1;
var push$2 = uncurryThis$7([].push);
var createMethod$2 = function(TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function($this, callbackfn, that, specificCreate) {
    var O = toObject$4($this);
    var self2 = IndexedObject(O);
    var boundFunction = bind$1(callbackfn, that);
    var length = lengthOfArrayLike$2(self2);
    var index = 0;
    var create4 = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create4($this, length) : IS_FILTER || IS_FILTER_REJECT ? create4($this, 0) : void 0;
    var value, result;
    for (; length > index; index++)
      if (NO_HOLES || index in self2) {
        value = self2[index];
        result = boundFunction(value, index, O);
        if (TYPE) {
          if (IS_MAP)
            target[index] = result;
          else if (result)
            switch (TYPE) {
              case 3:
                return true;
              case 5:
                return value;
              case 6:
                return index;
              case 2:
                push$2(target, value);
            }
          else
            switch (TYPE) {
              case 4:
                return false;
              case 7:
                push$2(target, value);
            }
        }
      }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};
var arrayIteration = {
  forEach: createMethod$2(0),
  map: createMethod$2(1),
  filter: createMethod$2(2),
  some: createMethod$2(3),
  every: createMethod$2(4),
  find: createMethod$2(5),
  findIndex: createMethod$2(6),
  filterReject: createMethod$2(7)
};
var $$6 = _export;
var global$8 = global$y;
var getBuiltIn = getBuiltIn$6;
var apply = functionApply;
var call$4 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var DESCRIPTORS$4 = descriptors;
var NATIVE_SYMBOL$1 = nativeSymbol;
var fails$5 = fails$e;
var hasOwn$2 = hasOwnProperty_1;
var isArray$1 = isArray$3;
var isCallable$5 = isCallable$h;
var isObject$1 = isObject$8;
var isPrototypeOf$2 = objectIsPrototypeOf;
var isSymbol = isSymbol$3;
var anObject$6 = anObject$b;
var toObject$3 = toObject$6;
var toIndexedObject$3 = toIndexedObject$a;
var toPropertyKey = toPropertyKey$4;
var $toString$1 = toString$4;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;
var nativeObjectCreate = objectCreate;
var objectKeys$1 = objectKeys$3;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;
var definePropertiesModule = objectDefineProperties;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var arraySlice = arraySlice$1;
var redefine$4 = redefine$6.exports;
var shared = shared$4.exports;
var sharedKey$1 = sharedKey$4;
var hiddenKeys = hiddenKeys$5;
var uid = uid$3;
var wellKnownSymbol$9 = wellKnownSymbol$g;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol$1 = defineWellKnownSymbol$2;
var setToStringTag$2 = setToStringTag$3;
var InternalStateModule$2 = internalState;
var $forEach = arrayIteration.forEach;
var HIDDEN = sharedKey$1("hidden");
var SYMBOL = "Symbol";
var PROTOTYPE = "prototype";
var TO_PRIMITIVE = wellKnownSymbol$9("toPrimitive");
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$2 = InternalStateModule$2.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE];
var $Symbol = global$8.Symbol;
var SymbolPrototype$1 = $Symbol && $Symbol[PROTOTYPE];
var TypeError$3 = global$8.TypeError;
var QObject = global$8.QObject;
var $stringify = getBuiltIn("JSON", "stringify");
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule$1.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push$1 = uncurryThis$6([].push);
var AllSymbols = shared("symbols");
var ObjectPrototypeSymbols = shared("op-symbols");
var StringToSymbolRegistry = shared("string-to-symbol-registry");
var SymbolToStringRegistry = shared("symbol-to-string-registry");
var WellKnownSymbolsStore = shared("wks");
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
var setSymbolDescriptor = DESCRIPTORS$4 && fails$5(function() {
  return nativeObjectCreate(nativeDefineProperty({}, "a", {
    get: function() {
      return nativeDefineProperty(this, "a", {
        value: 7
      }).a;
    }
  })).a != 7;
}) ? function(O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor)
    delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;
var wrap = function(tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype$1);
  setInternalState$2(symbol, {
    type: SYMBOL,
    tag,
    description
  });
  if (!DESCRIPTORS$4)
    symbol.description = description;
  return symbol;
};
var $defineProperty = function defineProperty3(O, P, Attributes) {
  if (O === ObjectPrototype$1)
    $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$6(O);
  var key = toPropertyKey(P);
  anObject$6(Attributes);
  if (hasOwn$2(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn$2(O, HIDDEN))
        nativeDefineProperty(O, HIDDEN, createPropertyDescriptor$1(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn$2(O, HIDDEN) && O[HIDDEN][key])
        O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, {
        enumerable: createPropertyDescriptor$1(0, false)
      });
    }
    return setSymbolDescriptor(O, key, Attributes);
  }
  return nativeDefineProperty(O, key, Attributes);
};
var $defineProperties = function defineProperties2(O, Properties) {
  anObject$6(O);
  var properties = toIndexedObject$3(Properties);
  var keys4 = objectKeys$1(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys4, function(key) {
    if (!DESCRIPTORS$4 || call$4($propertyIsEnumerable$1, properties, key))
      $defineProperty(O, key, properties[key]);
  });
  return O;
};
var $create = function create2(O, Properties) {
  return Properties === void 0 ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};
var $propertyIsEnumerable$1 = function propertyIsEnumerable2(V) {
  var P = toPropertyKey(V);
  var enumerable = call$4(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype$1 && hasOwn$2(AllSymbols, P) && !hasOwn$2(ObjectPrototypeSymbols, P))
    return false;
  return enumerable || !hasOwn$2(this, P) || !hasOwn$2(AllSymbols, P) || hasOwn$2(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor3(O, P) {
  var it = toIndexedObject$3(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype$1 && hasOwn$2(AllSymbols, key) && !hasOwn$2(ObjectPrototypeSymbols, key))
    return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn$2(AllSymbols, key) && !(hasOwn$2(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};
var $getOwnPropertyNames = function getOwnPropertyNames3(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$3(O));
  var result = [];
  $forEach(names, function(key) {
    if (!hasOwn$2(AllSymbols, key) && !hasOwn$2(hiddenKeys, key))
      push$1(result, key);
  });
  return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$3(O));
  var result = [];
  $forEach(names, function(key) {
    if (hasOwn$2(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn$2(ObjectPrototype$1, key))) {
      push$1(result, AllSymbols[key]);
    }
  });
  return result;
};
if (!NATIVE_SYMBOL$1) {
  $Symbol = function Symbol2() {
    if (isPrototypeOf$2(SymbolPrototype$1, this))
      throw TypeError$3("Symbol is not a constructor");
    var description = !arguments.length || arguments[0] === void 0 ? void 0 : $toString$1(arguments[0]);
    var tag = uid(description);
    var setter = function(value) {
      if (this === ObjectPrototype$1)
        call$4(setter, ObjectPrototypeSymbols, value);
      if (hasOwn$2(this, HIDDEN) && hasOwn$2(this[HIDDEN], tag))
        this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor$1(1, value));
    };
    if (DESCRIPTORS$4 && USE_SETTER)
      setSymbolDescriptor(ObjectPrototype$1, tag, {
        configurable: true,
        set: setter
      });
    return wrap(tag, description);
  };
  SymbolPrototype$1 = $Symbol[PROTOTYPE];
  redefine$4(SymbolPrototype$1, "toString", function toString4() {
    return getInternalState$2(this).tag;
  });
  redefine$4($Symbol, "withoutSetter", function(description) {
    return wrap(uid(description), description);
  });
  propertyIsEnumerableModule.f = $propertyIsEnumerable$1;
  definePropertyModule$1.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
  wrappedWellKnownSymbolModule.f = function(name) {
    return wrap(wellKnownSymbol$9(name), name);
  };
  if (DESCRIPTORS$4) {
    nativeDefineProperty(SymbolPrototype$1, "description", {
      configurable: true,
      get: function description() {
        return getInternalState$2(this).description;
      }
    });
    {
      redefine$4(ObjectPrototype$1, "propertyIsEnumerable", $propertyIsEnumerable$1, {
        unsafe: true
      });
    }
  }
}
$$6({
  global: true,
  wrap: true,
  forced: !NATIVE_SYMBOL$1,
  sham: !NATIVE_SYMBOL$1
}, {
  Symbol: $Symbol
});
$forEach(objectKeys$1(WellKnownSymbolsStore), function(name) {
  defineWellKnownSymbol$1(name);
});
$$6({
  target: SYMBOL,
  stat: true,
  forced: !NATIVE_SYMBOL$1
}, {
  for: function(key) {
    var string = $toString$1(key);
    if (hasOwn$2(StringToSymbolRegistry, string))
      return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym))
      throw TypeError$3(sym + " is not a symbol");
    if (hasOwn$2(SymbolToStringRegistry, sym))
      return SymbolToStringRegistry[sym];
  },
  useSetter: function() {
    USE_SETTER = true;
  },
  useSimple: function() {
    USE_SETTER = false;
  }
});
$$6({
  target: "Object",
  stat: true,
  forced: !NATIVE_SYMBOL$1,
  sham: !DESCRIPTORS$4
}, {
  create: $create,
  defineProperty: $defineProperty,
  defineProperties: $defineProperties,
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});
$$6({
  target: "Object",
  stat: true,
  forced: !NATIVE_SYMBOL$1
}, {
  getOwnPropertyNames: $getOwnPropertyNames,
  getOwnPropertySymbols: $getOwnPropertySymbols
});
$$6({
  target: "Object",
  stat: true,
  forced: fails$5(function() {
    getOwnPropertySymbolsModule.f(1);
  })
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols2(it) {
    return getOwnPropertySymbolsModule.f(toObject$3(it));
  }
});
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL$1 || fails$5(function() {
    var symbol = $Symbol();
    return $stringify([symbol]) != "[null]" || $stringify({
      a: symbol
    }) != "{}" || $stringify(Object(symbol)) != "{}";
  });
  $$6({
    target: "JSON",
    stat: true,
    forced: FORCED_JSON_STRINGIFY
  }, {
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var $replacer = replacer;
      if (!isObject$1(replacer) && it === void 0 || isSymbol(it))
        return;
      if (!isArray$1(replacer))
        replacer = function(key, value) {
          if (isCallable$5($replacer))
            value = call$4($replacer, this, key, value);
          if (!isSymbol(value))
            return value;
        };
      args[1] = replacer;
      return apply($stringify, null, args);
    }
  });
}
if (!SymbolPrototype$1[TO_PRIMITIVE]) {
  var valueOf = SymbolPrototype$1.valueOf;
  redefine$4(SymbolPrototype$1, TO_PRIMITIVE, function(hint) {
    return call$4(valueOf, this);
  });
}
setToStringTag$2($Symbol, SYMBOL);
hiddenKeys[HIDDEN] = true;
var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$1 = classof$5;
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString2() {
  return "[object " + classof$1(this) + "]";
};
var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$3 = redefine$6.exports;
var toString$3 = objectToString;
if (!TO_STRING_TAG_SUPPORT) {
  redefine$3(Object.prototype, "toString", toString$3, {
    unsafe: true
  });
}
var anObject$5 = anObject$b;
var regexpFlags = function() {
  var that = anObject$5(this);
  var result = "";
  if (that.global)
    result += "g";
  if (that.ignoreCase)
    result += "i";
  if (that.multiline)
    result += "m";
  if (that.dotAll)
    result += "s";
  if (that.unicode)
    result += "u";
  if (that.sticky)
    result += "y";
  return result;
};
var uncurryThis$5 = functionUncurryThis;
var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var redefine$2 = redefine$6.exports;
var anObject$4 = anObject$b;
var isPrototypeOf$1 = objectIsPrototypeOf;
var $toString = toString$4;
var fails$4 = fails$e;
var regExpFlags = regexpFlags;
var TO_STRING = "toString";
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];
var getFlags = uncurryThis$5(regExpFlags);
var NOT_GENERIC = fails$4(function() {
  return n$ToString.call({
    source: "a",
    flags: "b"
  }) != "/a/b";
});
var INCORRECT_NAME = PROPER_FUNCTION_NAME$1 && n$ToString.name != TO_STRING;
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$2(RegExp.prototype, TO_STRING, function toString4() {
    var R = anObject$4(this);
    var p = $toString(R.source);
    var rf = R.flags;
    var f = $toString(rf === void 0 && isPrototypeOf$1(RegExpPrototype, R) && !("flags" in RegExpPrototype) ? getFlags(R) : rf);
    return "/" + p + "/" + f;
  }, {
    unsafe: true
  });
}
var $$5 = _export;
var toObject$2 = toObject$6;
var nativeKeys = objectKeys$3;
var fails$3 = fails$e;
var FAILS_ON_PRIMITIVES = fails$3(function() {
  nativeKeys(1);
});
$$5({
  target: "Object",
  stat: true,
  forced: FAILS_ON_PRIMITIVES
}, {
  keys: function keys3(it) {
    return nativeKeys(toObject$2(it));
  }
});
var fails$2 = fails$e;
var wellKnownSymbol$8 = wellKnownSymbol$g;
var V8_VERSION = engineV8Version;
var SPECIES$1 = wellKnownSymbol$8("species");
var arrayMethodHasSpeciesSupport$1 = function(METHOD_NAME) {
  return V8_VERSION >= 51 || !fails$2(function() {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function() {
      return {
        foo: 1
      };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};
var $$4 = _export;
var global$7 = global$y;
var isArray2 = isArray$3;
var isConstructor$1 = isConstructor$3;
var isObject = isObject$8;
var toAbsoluteIndex = toAbsoluteIndex$3;
var lengthOfArrayLike$1 = lengthOfArrayLike$5;
var toIndexedObject$2 = toIndexedObject$a;
var createProperty$1 = createProperty$4;
var wellKnownSymbol$7 = wellKnownSymbol$g;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$1;
var un$Slice = arraySlice$1;
var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice");
var SPECIES = wellKnownSymbol$7("species");
var Array$2 = global$7.Array;
var max = Math.max;
$$4({
  target: "Array",
  proto: true,
  forced: !HAS_SPECIES_SUPPORT
}, {
  slice: function slice(start, end) {
    var O = toIndexedObject$2(this);
    var length = lengthOfArrayLike$1(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === void 0 ? length : end, length);
    var Constructor, result, n;
    if (isArray2(O)) {
      Constructor = O.constructor;
      if (isConstructor$1(Constructor) && (Constructor === Array$2 || isArray2(Constructor.prototype))) {
        Constructor = void 0;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null)
          Constructor = void 0;
      }
      if (Constructor === Array$2 || Constructor === void 0) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === void 0 ? Array$2 : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++)
      if (k in O)
        createProperty$1(result, n, O[k]);
    result.length = n;
    return result;
  }
});
var DESCRIPTORS$3 = descriptors;
var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var uncurryThis$4 = functionUncurryThis;
var defineProperty$2 = objectDefineProperty.f;
var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis$4(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis$4(nameRE.exec);
var NAME = "name";
if (DESCRIPTORS$3 && !FUNCTION_NAME_EXISTS) {
  defineProperty$2(FunctionPrototype, NAME, {
    configurable: true,
    get: function() {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return "";
      }
    }
  });
}
var call$3 = functionCall;
var anObject$3 = anObject$b;
var getMethod$1 = getMethod$3;
var iteratorClose$1 = function(iterator, kind, value) {
  var innerResult, innerError;
  anObject$3(iterator);
  try {
    innerResult = getMethod$1(iterator, "return");
    if (!innerResult) {
      if (kind === "throw")
        throw value;
      return value;
    }
    innerResult = call$3(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === "throw")
    throw value;
  if (innerError)
    throw innerResult;
  anObject$3(innerResult);
  return value;
};
var anObject$2 = anObject$b;
var iteratorClose = iteratorClose$1;
var callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES2) {
  try {
    return ENTRIES2 ? fn(anObject$2(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, "throw", error);
  }
};
var iterators = {};
var wellKnownSymbol$6 = wellKnownSymbol$g;
var Iterators$4 = iterators;
var ITERATOR$5 = wellKnownSymbol$6("iterator");
var ArrayPrototype$1 = Array.prototype;
var isArrayIteratorMethod$1 = function(it) {
  return it !== void 0 && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$5] === it);
};
var classof = classof$5;
var getMethod = getMethod$3;
var Iterators$3 = iterators;
var wellKnownSymbol$5 = wellKnownSymbol$g;
var ITERATOR$4 = wellKnownSymbol$5("iterator");
var getIteratorMethod$2 = function(it) {
  if (it != void 0)
    return getMethod(it, ITERATOR$4) || getMethod(it, "@@iterator") || Iterators$3[classof(it)];
};
var global$6 = global$y;
var call$2 = functionCall;
var aCallable = aCallable$3;
var anObject$1 = anObject$b;
var tryToString = tryToString$2;
var getIteratorMethod$1 = getIteratorMethod$2;
var TypeError$2 = global$6.TypeError;
var getIterator$1 = function(argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable(iteratorMethod))
    return anObject$1(call$2(iteratorMethod, argument));
  throw TypeError$2(tryToString(argument) + " is not iterable");
};
var global$5 = global$y;
var bind = functionBindContext;
var call$1 = functionCall;
var toObject$1 = toObject$6;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var isConstructor3 = isConstructor$3;
var lengthOfArrayLike = lengthOfArrayLike$5;
var createProperty = createProperty$4;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var Array$1 = global$5.Array;
var arrayFrom = function from(arrayLike) {
  var O = toObject$1(arrayLike);
  var IS_CONSTRUCTOR = isConstructor3(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
  var mapping = mapfn !== void 0;
  if (mapping)
    mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : void 0);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next2, value;
  if (iteratorMethod && !(this == Array$1 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next2 = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (; !(step = call$1(next2, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array$1(length);
    for (; length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};
var wellKnownSymbol$4 = wellKnownSymbol$g;
var ITERATOR$3 = wellKnownSymbol$4("iterator");
var SAFE_CLOSING = false;
try {
  var called = 0;
  var iteratorWithReturn = {
    next: function() {
      return {
        done: !!called++
      };
    },
    return: function() {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$3] = function() {
    return this;
  };
  Array.from(iteratorWithReturn, function() {
    throw 2;
  });
} catch (error) {
}
var checkCorrectnessOfIteration$1 = function(exec2, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING)
    return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$3] = function() {
      return {
        next: function() {
          return {
            done: ITERATION_SUPPORT = true
          };
        }
      };
    };
    exec2(object);
  } catch (error) {
  }
  return ITERATION_SUPPORT;
};
var $$3 = _export;
var from2 = arrayFrom;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
  Array.from(iterable);
});
$$3({
  target: "Array",
  stat: true,
  forced: INCORRECT_ITERATION
}, {
  from: from2
});
var uncurryThis$3 = functionUncurryThis;
var toIntegerOrInfinity = toIntegerOrInfinity$3;
var toString$2 = toString$4;
var requireObjectCoercible = requireObjectCoercible$3;
var charAt$1 = uncurryThis$3("".charAt);
var charCodeAt = uncurryThis$3("".charCodeAt);
var stringSlice$1 = uncurryThis$3("".slice);
var createMethod$1 = function(CONVERT_TO_STRING) {
  return function($this, pos) {
    var S = toString$2(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size)
      return CONVERT_TO_STRING ? "" : void 0;
    first = charCodeAt(S, position);
    return first < 55296 || first > 56319 || position + 1 === size || (second = charCodeAt(S, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt$1(S, position) : first : CONVERT_TO_STRING ? stringSlice$1(S, position, position + 2) : (first - 55296 << 10) + (second - 56320) + 65536;
  };
};
var stringMultibyte = {
  codeAt: createMethod$1(false),
  charAt: createMethod$1(true)
};
var fails$1 = fails$e;
var correctPrototypeGetter = !fails$1(function() {
  function F() {
  }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});
var global$4 = global$y;
var hasOwn$1 = hasOwnProperty_1;
var isCallable$4 = isCallable$h;
var toObject = toObject$6;
var sharedKey = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;
var IE_PROTO = sharedKey("IE_PROTO");
var Object$1 = global$4.Object;
var ObjectPrototype = Object$1.prototype;
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? Object$1.getPrototypeOf : function(O) {
  var object = toObject(O);
  if (hasOwn$1(object, IE_PROTO))
    return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$4(constructor) && object instanceof constructor) {
    return constructor.prototype;
  }
  return object instanceof Object$1 ? ObjectPrototype : null;
};
var fails = fails$e;
var isCallable$3 = isCallable$h;
var getPrototypeOf$1 = objectGetPrototypeOf;
var redefine$1 = redefine$6.exports;
var wellKnownSymbol$3 = wellKnownSymbol$g;
var ITERATOR$2 = wellKnownSymbol$3("iterator");
var BUGGY_SAFARI_ITERATORS$1 = false;
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;
if ([].keys) {
  arrayIterator = [].keys();
  if (!("next" in arrayIterator))
    BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
      IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}
var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == void 0 || fails(function() {
  var test2 = {};
  return IteratorPrototype$2[ITERATOR$2].call(test2) !== test2;
});
if (NEW_ITERATOR_PROTOTYPE)
  IteratorPrototype$2 = {};
if (!isCallable$3(IteratorPrototype$2[ITERATOR$2])) {
  redefine$1(IteratorPrototype$2, ITERATOR$2, function() {
    return this;
  });
}
var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$5;
var setToStringTag$1 = setToStringTag$3;
var Iterators$2 = iterators;
var returnThis$1 = function() {
  return this;
};
var createIteratorConstructor$1 = function(IteratorConstructor, NAME2, next2, ENUMERABLE_NEXT) {
  var TO_STRING_TAG2 = NAME2 + " Iterator";
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, {
    next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next2)
  });
  setToStringTag$1(IteratorConstructor, TO_STRING_TAG2, false);
  Iterators$2[TO_STRING_TAG2] = returnThis$1;
  return IteratorConstructor;
};
var global$3 = global$y;
var isCallable$2 = isCallable$h;
var String$1 = global$3.String;
var TypeError$1 = global$3.TypeError;
var aPossiblePrototype$1 = function(argument) {
  if (typeof argument == "object" || isCallable$2(argument))
    return argument;
  throw TypeError$1("Can't set " + String$1(argument) + " as a prototype");
};
var uncurryThis$2 = functionUncurryThis;
var anObject = anObject$b;
var aPossiblePrototype = aPossiblePrototype$1;
var objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var CORRECT_SETTER = false;
  var test2 = {};
  var setter;
  try {
    setter = uncurryThis$2(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
    setter(test2, []);
    CORRECT_SETTER = test2 instanceof Array;
  } catch (error) {
  }
  return function setPrototypeOf2(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER)
      setter(O, proto);
    else
      O.__proto__ = proto;
    return O;
  };
}() : void 0);
var $$2 = _export;
var call = functionCall;
var FunctionName = functionName;
var isCallable$1 = isCallable$h;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$3;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var redefine = redefine$6.exports;
var wellKnownSymbol$2 = wellKnownSymbol$g;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;
var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$2("iterator");
var KEYS = "keys";
var VALUES = "values";
var ENTRIES = "entries";
var returnThis = function() {
  return this;
};
var defineIterator$2 = function(Iterable, NAME2, IteratorConstructor, next2, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME2, next2);
  var getIterationMethod = function(KIND) {
    if (KIND === DEFAULT && defaultIterator)
      return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
      return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS:
        return function keys4() {
          return new IteratorConstructor(this, KIND);
        };
      case VALUES:
        return function values2() {
          return new IteratorConstructor(this, KIND);
        };
      case ENTRIES:
        return function entries2() {
          return new IteratorConstructor(this, KIND);
        };
    }
    return function() {
      return new IteratorConstructor(this);
    };
  };
  var TO_STRING_TAG2 = NAME2 + " Iterator";
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME2 == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$1(CurrentIteratorPrototype[ITERATOR$1])) {
          redefine(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG2, true);
    }
  }
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$1(IterablePrototype, "name", VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values2() {
        return call(nativeIterator, this);
      };
    }
  }
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED)
      for (KEY in methods) {
        if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
          redefine(IterablePrototype, KEY, methods[KEY]);
        }
      }
    else
      $$2({
        target: NAME2,
        proto: true,
        forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
      }, methods);
  }
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    redefine(IterablePrototype, ITERATOR$1, defaultIterator, {
      name: DEFAULT
    });
  }
  Iterators$1[NAME2] = defaultIterator;
  return methods;
};
var charAt = stringMultibyte.charAt;
var toString$1 = toString$4;
var InternalStateModule$1 = internalState;
var defineIterator$1 = defineIterator$2;
var STRING_ITERATOR = "String Iterator";
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(STRING_ITERATOR);
defineIterator$1(String, "String", function(iterated) {
  setInternalState$1(this, {
    type: STRING_ITERATOR,
    string: toString$1(iterated),
    index: 0
  });
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length)
    return {
      value: void 0,
      done: true
    };
  point = charAt(string, index);
  state.index += point.length;
  return {
    value: point,
    done: false
  };
});
var $$1 = _export;
var DESCRIPTORS$2 = descriptors;
var global$2 = global$y;
var uncurryThis$1 = functionUncurryThis;
var hasOwn2 = hasOwnProperty_1;
var isCallable = isCallable$h;
var isPrototypeOf = objectIsPrototypeOf;
var toString3 = toString$4;
var defineProperty$1 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;
var NativeSymbol = global$2.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
if (DESCRIPTORS$2 && isCallable(NativeSymbol) && (!("description" in SymbolPrototype) || NativeSymbol().description !== void 0)) {
  var EmptyStringDescriptionStore = {};
  var SymbolWrapper = function Symbol2() {
    var description = arguments.length < 1 || arguments[0] === void 0 ? void 0 : toString3(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === void 0 ? NativeSymbol() : NativeSymbol(description);
    if (description === "")
      EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;
  var NATIVE_SYMBOL = String(NativeSymbol("test")) == "Symbol(test)";
  var symbolToString = uncurryThis$1(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis$1(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis$1("".replace);
  var stringSlice = uncurryThis$1("".slice);
  defineProperty$1(SymbolPrototype, "description", {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn2(EmptyStringDescriptionStore, symbol))
        return "";
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, "$1");
      return desc === "" ? void 0 : desc;
    }
  });
  $$1({
    global: true,
    forced: true
  }, {
    Symbol: SymbolWrapper
  });
}
var defineWellKnownSymbol = defineWellKnownSymbol$2;
defineWellKnownSymbol("iterator");
var wellKnownSymbol$1 = wellKnownSymbol$g;
var create3 = objectCreate;
var definePropertyModule = objectDefineProperty;
var UNSCOPABLES = wellKnownSymbol$1("unscopables");
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] == void 0) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create3(null)
  });
}
var addToUnscopables$1 = function(key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};
var toIndexedObject$1 = toIndexedObject$a;
var addToUnscopables = addToUnscopables$1;
var Iterators = iterators;
var InternalStateModule = internalState;
var defineProperty4 = objectDefineProperty.f;
var defineIterator = defineIterator$2;
var DESCRIPTORS$1 = descriptors;
var ARRAY_ITERATOR = "Array Iterator";
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
var es_array_iterator = defineIterator(Array, "Array", function(iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$1(iterated),
    index: 0,
    kind
  });
}, function() {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = void 0;
    return {
      value: void 0,
      done: true
    };
  }
  if (kind == "keys")
    return {
      value: index,
      done: false
    };
  if (kind == "values")
    return {
      value: target[index],
      done: false
    };
  return {
    value: [index, target[index]],
    done: false
  };
}, "values");
var values = Iterators.Arguments = Iterators.Array;
addToUnscopables("keys");
addToUnscopables("values");
addToUnscopables("entries");
if (DESCRIPTORS$1 && values.name !== "values")
  try {
    defineProperty4(values, "name", {
      value: "values"
    });
  } catch (error) {
  }
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};
var documentCreateElement = documentCreateElement$2;
var classList = documentCreateElement("span").classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;
var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? void 0 : DOMTokenListPrototype$1;
var global$1 = global$y;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty = createNonEnumerableProperty$5;
var wellKnownSymbol = wellKnownSymbol$g;
var ITERATOR = wellKnownSymbol("iterator");
var TO_STRING_TAG = wellKnownSymbol("toStringTag");
var ArrayValues = ArrayIteratorMethods.values;
var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    if (CollectionPrototype[ITERATOR] !== ArrayValues)
      try {
        createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
      } catch (error) {
        CollectionPrototype[ITERATOR] = ArrayValues;
      }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME])
      for (var METHOD_NAME in ArrayIteratorMethods) {
        if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME])
          try {
            createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
          } catch (error) {
            CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
          }
      }
  }
};
for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$1[COLLECTION_NAME] && global$1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}
handlePrototype(DOMTokenListPrototype, "DOMTokenList");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest();
}
var DESCRIPTORS = descriptors;
var uncurryThis = functionUncurryThis;
var objectKeys = objectKeys$3;
var toIndexedObject = toIndexedObject$a;
var $propertyIsEnumerable = objectPropertyIsEnumerable.f;
var propertyIsEnumerable3 = uncurryThis($propertyIsEnumerable);
var push = uncurryThis([].push);
var createMethod = function(TO_ENTRIES) {
  return function(it) {
    var O = toIndexedObject(it);
    var keys4 = objectKeys(O);
    var length = keys4.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys4[i++];
      if (!DESCRIPTORS || propertyIsEnumerable3(O, key)) {
        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};
var objectToArray = {
  entries: createMethod(true),
  values: createMethod(false)
};
var $ = _export;
var $entries = objectToArray.entries;
$({
  target: "Object",
  stat: true
}, {
  entries: function entries(O) {
    return $entries(O);
  }
});
var accountModules = {
  title: "Default account Modules",
  permission_view_dashboard: "Dashboard",
  permission_view_property_groups: "Property Group",
  permission_view_units: "Unit",
  document: "Document",
  permission_view_documents: "Document Manager",
  permission_view_documents_setup: "Setup Document Manager",
  templates: "Templates",
  permission_view_templates: "Templates",
  permission_view_templates_calendar: "Template Calendar",
  permission_view_trigger_templates: "Trigger templates",
  permission_view_code_templates_tasks: "Code templates tasks",
  permission_view_workflows: "WorkFlow",
  permission_view_unit_workflows: "Unit WorkFlow",
  permission_view_make_ready_board: "Make Ready board",
  permission_resident_inspection: "Resident Inspections Enabled",
  permission_view_dynamic_forms: "Dynamic Form",
  permission_view_on_demand_instructions: "On Demand Instruction",
  report: "Report",
  permission_view_reports: "Reports",
  permission_view_reports_mimo: "MIMO",
  permission_view_contacts: "Contacts",
  permission_view_work_order: "Work Order",
  permission_upload_sftp: "SFTP",
  permission_live_chat: "Messenger",
  other: "Other",
  permission_mobile_photo_annotation: "Mobile Photo Annotation",
  approval_steps: "Approval Step",
  permission_define_approval_steps: "Define approval steps",
  sso: "SSO",
  permission_login_with_sso: "Login with SSO",
  permission_sso_get_properties_from_idp: "Get properties from Idp",
  permission_sso_get_role_from_idp: "Get roles from Idp"
};
var adminModules = {
  title: "Admin Modules",
  permission_view_on_demand_instructions: "On Demand Instructions",
  permission_view_dynamic_forms: "Dynamic Forms",
  permission_view_reports: "Reports",
  permission_view_templates: "Templates",
  permission_view_utilities: "Utilities",
  permission_view_work_orders: "Work Orders",
  permission_live_chat: "Messenger"
};
var imageUploader = {
  title: "Image upload",
  content: "Drop files to upload or click to browse",
  zoom: "Zoom"
};
var select = {
  none: "None"
};
var userAccountsCards = {
  property: "{{ count }} property",
  property_plural: "{{ count }} properties"
};
var maintenance = {
  content: {
    title: "The Leonardo247 site is temporarily unavailable due to maintenance.",
    subtitle: "We will be back up and running again. We apologize for any inconvenience and thank you for your patience."
  }
};
var menu = {
  management: "Management"
};
var property = {
  impersonate: "You are impersonating",
  exit: "Exit view",
  filter_by: "Filter by",
  actions: {
    add: "Add {{ type }}",
    addSystemUser: "Add system user",
    export: "Export",
    exportAll: "Export all users",
    exportRoles: "Export user roles",
    exportReport: "Export report",
    filter: "Filter",
    disable: "Disable",
    resetPassword: "Reset password",
    workAsUser: "Work as user"
  },
  input: {
    email: "Email",
    search: "Search by {{ type }} name"
  },
  filter: {
    white_label: "Client Instance",
    account: "Account",
    property: "Property",
    group: "Property Group",
    portfolio: "Portfolio",
    role: "Role",
    active: "User status",
    system: "System admin"
  },
  checkbox: {
    active: "Active users",
    disabled: "Disabled users",
    system: "Is system admin"
  },
  list: {
    type: "{{ count }} property selected",
    type_plural: "{{ count }} properties selected",
    columns: {
      id: "Id",
      property_name: "Property Name",
      account: "Account",
      units: "Units",
      unmatched_units: "Unmatched units"
    }
  }
};
var units = {
  type: "Type",
  area: "Sq feet",
  areaAbbreviated: "sq. ft",
  building: "Building",
  merge: "Merge",
  unmerge: "Unmerge",
  search: "Search units",
  mergeSuggestions: "Merge Suggestions",
  mergeUnitSrc: "Select source unit to be merged",
  mergeUnitDst: "Select destination unit to merge with",
  mergeQueue: "Merge Queue",
  mergeQueueClear: "Empty Queue",
  mergeQueueMergeAll: "Merge All",
  mergeQueueEmptyState: "The units to be merged will appear here once you select them using the options above. Before you leave this page, remember to merge them individually or using the “Merge All” button.",
  mergeHistory: "Merge History",
  queueAll: "Queue All",
  queue: "Queue",
  mergeSuggestionEmptyState: "No merge suggestions available. You can merge them manually selecting them from the list on the left.",
  mergeLeaveWarningTitle: "Merge units pending",
  mergeLeaveWarning: "There are units pending to merge. Do you want to merge them before leaving?",
  mergeExit: "Exit without merging",
  addQueueDialogTitle: "Units Merge",
  addQueueDialogText: "Would you like to merge these units?",
  addQueueDialogAccept: "Accept",
  addQueueDialogCancel: "Cancel"
};
var user = {
  impersonate: "You are impersonating",
  exit: "Exit view",
  filter_by: "Filter by",
  actions: {
    add: "Add {{ type }}",
    addSystemUser: "Add system user",
    export: "Export",
    exportAll: "Export all users",
    exportRoles: "Export user roles",
    exportReport: "Export report",
    filter: "Filter",
    disable: "Disable",
    resetPassword: "Reset password",
    workAsUser: "Work as user"
  },
  input: {
    email: "Email",
    search: "Search by {{ type }} name"
  },
  filter: {
    white_label: "Client Instance",
    account: "Account",
    property: "Property",
    group: "Property Group",
    portfolio: "Portfolio",
    role: "Role",
    active: "User status",
    system: "System admin"
  },
  checkbox: {
    active: "Active users",
    disabled: "Disabled users",
    system: "Is system admin"
  },
  list: {
    type: "{{ count }} user selected",
    type_plural: "{{ count }} users selected",
    columns: {
      id: "Id",
      name: "Name",
      email: "Email",
      multiAccount: "Multiaccount",
      mainAccount: "Main account",
      userRole: "User role"
    }
  },
  form: {
    logo: {
      title: "User pic upload",
      description: "For better visualization make sure you upload your logo as a PNG or SVG with transparent background and whose colour contrasts the primary colour you selected."
    },
    config: {
      main: {
        title: "Edit user",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        userTitle: "Title"
      },
      status: {
        title: "User status",
        description: "User active"
      },
      password: {
        title: "Password",
        button: "Send reset password email",
        description: "You can send an email to the user with instructions to reset password or fill below to set a new one.",
        newPassword: "New password",
        confirm: "Confirm password"
      }
    },
    accounts: {
      main: {
        title: "Accounts",
        describe: "Associate user to a new account",
        notify: "Notify me by email when the user dials a note as important"
      }
    }
  },
  role: {
    type: "{{ count }} role selected",
    type_plural: "{{ count }} roles selected",
    columns: {
      id: "Id",
      name: "Name",
      portfolio: "Portfolio",
      property: "Property",
      user: "User",
      document: "Document",
      template: "Template",
      workflow: "Workflow",
      note: "Note",
      dynamic_form: "Dynamic form",
      on_demand_instruction: "On demand instruction",
      on_demand_category: "On demand category",
      unit: "Unit",
      work_order: "Work order",
      contact: "Contact",
      vendor: "Vendor",
      approval_steps: "Approval steps",
      charge_codes: "Charge codes"
    },
    permissions: {
      all: "All",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      activate: "Activate",
      complete: "Complete",
      assign_users_to: "Assign users to",
      deactivate: "Deactivate",
      define: "Define",
      view: "View"
    }
  }
};
var whiteLabel = {
  breadcrumb: {
    list: "White label"
  },
  filter: "Search by white label name",
  actions: {
    add: "Add white label",
    clone: "Clone",
    preview: "Preview"
  },
  preview: {
    title: "Previewing {{ name }}",
    content: "Close this window to return",
    close: "Close"
  },
  imageUploader: {
    help: "For better visualization make sure you upload your logo as a PNG or SVG with transparent background and whose colour contrasts the primary colour you selected."
  },
  form: {
    config: {
      title: "Branding configuration",
      name: "White Label Name",
      default_from_email: "Default from email",
      company_help_email: "Company help email"
    },
    images: {
      title: "Logo & Images",
      logo: {
        imageUploaderTitle: "Logo upload",
        help: "Full logo for printing"
      },
      background: {
        imageUploaderTitle: "Background log-in image upload",
        help: "Background image for log-in window"
      }
    },
    colors: {
      brand: "Brand colors",
      functional: "Functional colors",
      primaryColorHelp: "Primary color. Click to change",
      secondaryColorHelp: "Secondary color. Click to change",
      successColorHelp: "Success color. Click to change",
      warningColorHelp: "Warning color. Click to change",
      errorColorHelp: "Error color. Click to change",
      auxColorHelp: "Auxiliary color. Click to change"
    },
    adminModule: {
      description: "All modules selected below will be activated for the white label admin accounts."
    },
    accountModule: {
      description: "All modules selected below will be activated for the default accounts created under this white label."
    }
  }
};
var en = {
  title: "Leonardo",
  status: {
    active: "Active",
    disabled: "Disabled"
  },
  formRules: {
    required: "This field is required",
    notValid: "The value entered does not meet the requirements",
    email: "Invalid email",
    url: "Invalid url",
    pattern: "The value entered is not valid",
    minlength: "The value entered is too short, minimum is {{minlength}}",
    maxlength: "The value entered is too long, maximum is {{maxlength}}",
    passwordVerify: "Password doesn't match",
    passwordString: "Password should contains at least one character and one number",
    exportEmail: "Emails in red are not valid email addresses. Please correct them to continue."
  },
  actions: {
    activateAll: "Activate all",
    selectAll: "Select all",
    disableAll: "Disable all",
    cancel: "Cancel",
    delete: "Delete",
    disable: "Disable",
    discard: "Discard",
    edit: "Edit",
    save: "Save",
    export: "Export",
    filter: "Filter",
    clear: "Clear",
    submit: "Submit",
    close: "Close"
  },
  menu,
  accountModules,
  adminModules,
  imageUploader,
  select,
  whiteLabel,
  units,
  user,
  property,
  maintenance,
  userAccountsCards
};
var es = {
  title: "Leonardo (ES)",
  formRules: {
    required: "Este campo es obligatorio",
    notValid: "El valor ingresado no cumple con los requisitos",
    email: "email inválido",
    url: "URL no válida",
    pattern: "El valor ingresado no es válido",
    minlength: "El valor ingresado es demasiado corto, el mínimo es {{minlength}}",
    maxlength: "El valor ingresado es demasiado largo, el máximo es {{maxlength}}",
    passwordVerify: "La contraseña no coincide",
    passwordString: "La contraseña debe contener al menos un carácter y un número"
  },
  actions: {
    submit: "Enviar",
    save: "Guardar",
    cancel: "Cancelar",
    deleteConfirm: "Sí, eliminar",
    reject: "Rechazar",
    confirm: "Confirmar"
  },
  common: {
    emptyTable: "Sin datos"
  }
};
function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp$1 = Object.defineProperty;
var __defProps$1 = Object.defineProperties;
var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols$1) {
    var _iterator = _createForOfIteratorHelper$1(__getOwnPropSymbols$1(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum$1.call(b, prop))
          __defNormalProp$1(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps$1 = function __spreadProps(a, b) {
  return __defProps$1(a, __getOwnPropDescs$1(b));
};
var locales = {
  en,
  es
};
var resources = Object.entries(locales).reduce(function(a, _ref) {
  var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
  return __spreadProps$1(__spreadValues$1({}, a), _defineProperty({}, key, {
    translation: value
  }));
}, {});
var defaultLang = "en";
function init() {
  i18next.use(initReactI18next).init({
    resources,
    defaultNS: "translation",
    fallbackNS: "translation",
    debug: false,
    saveMissing: true,
    lng: defaultLang,
    fallbackLng: defaultLang,
    interpolation: {
      escapeValue: false
    }
  });
  return i18next;
}
init();
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null)
          it.return();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp2 = function __defNormalProp3(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};
var __spreadValues2 = function __spreadValues3(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop))
      __defNormalProp2(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop))
          __defNormalProp2(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps2 = function __spreadProps3(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
function useTranslation(ns, options) {
  var _reactI18UseTranslati = useTranslation$1(ns, options), i18n = _reactI18UseTranslati.i18n, ready = _reactI18UseTranslati.ready;
  var tt = useCallback(function(key, opt) {
    return i18n.t(key.toString(), opt);
  }, [i18n]);
  var t = useCallback(function(key, opt) {
    return tt(key.toString(), opt);
  }, [tt]);
  var tHtml = useCallback(function(key, opt) {
    return /* @__PURE__ */ React.createElement(Trans, __spreadProps2(__spreadValues2({}, opt), {
      i18n,
      i18nKey: key
    }), opt == null ? void 0 : opt.children);
  }, [i18n]);
  var changeLanguage = useCallback(function(lang) {
    return i18n.changeLanguage(lang);
  }, [i18n]);
  return {
    t,
    tt,
    changeLanguage,
    languages: Object.keys(i18n.options.resources || {}),
    activeLanguage: i18n.language,
    i18n,
    ready,
    tHtml
  };
}
function I18nProvider(_ref) {
  var children = _ref.children, locale = _ref.locale;
  var _useTranslation = useTranslation(), i18n = _useTranslation.i18n, changeLanguage = _useTranslation.changeLanguage;
  useEffect(function() {
    changeLanguage(locale);
  }, [changeLanguage, locale]);
  return /* @__PURE__ */ React.createElement(I18nextProvider, {
    i18n
  }, children);
}
export {I18nProvider, useTranslation};
